<div id="testimonial" data-scroll>
    <div class="container-fluid mt-5 px-3 px-lg-5">
        <div class="row">
            <div class="col-12">
                <h2 class="home-title text-center">Valuable Feedback From Our Illustrious Alumni</h2>
            </div>

        </div>
        <owl-carousel-o [options]="customOptions">
            <ng-container *ngFor="let slide of testimonial">
                <ng-template carouselSlide [id]="slide.id">
                    <div class="row text-center">
                        <div class="col-lg-1"></div>
                        <div class="col-12 col-md-3 col-lg-3">
                            <div class="author">
                                <img appLazyload [src]="slide.imgUrl" [alt]="slide.name" class="mx-auto" />
                                <h5>{{slide.name}} <span> {{slide.degreee}}</span> <span>{{slide.position}}</span></h5>
                            </div>
                        </div>
                        <div class="col-12 col-md-9 col-lg-7">
                            <figure class="snip1192 mx-auto">
                                <blockquote>{{slide.description}}</blockquote>
                            </figure>
                        </div>
                        <div class="col-lg-1"></div>
                    </div>
                </ng-template>
            </ng-container>
        </owl-carousel-o>
    </div>
</div>